"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e=require("./index154.js");var r=e.toIntegerOrInfinity,i=Math.min,F=function(n){var t=r(n);return t>0?i(t,9007199254740991):0};exports.toLength=F;
